const form_name = 'addPaymentMethodForm';

const statuses = {
  new: {
    text: 'NEW',
    code: 'N',
  },
  approved: {
    text: 'APPROVED',
    code: 'A',
  },
  deleted: {
    text: 'DELETED',
    code: 'X',
  },
  rejected: {
    text: 'REJECTED',
    code: 'R',
  },
};

export default {
  form_name,
  statuses,
};



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/constants/payment-methods-constants.js